import { colors } from 'src/constants';
import { ManufacturerStatusOption } from '../types';

export const ManufacturerStatuses = {
    // Main PO statuses
    ACTIVE: 'active',
    INACTIVE: 'inactive',
  };

export const manufacturerStatusOptions: ManufacturerStatusOption[] = [
  {
    label: 'Active',
    value: ManufacturerStatuses.ACTIVE,
    color: colors.green[300]
  },
  {
    label: 'Inactive',
    value: ManufacturerStatuses.INACTIVE,
    color: colors.red[300]
  },
];
